<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    variant="primary"
    style="height:45px"
    @click="applyForJob()"
  >
    Apply Now
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { isUserLoggedIn, getUserData } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BButton,
  },
  props: { jobId: String },
  methods: {
    applyForJob() {
      if (isUserLoggedIn()) {
        if (this.profileIsComplete()) {
          this.confirmSubmit(this.jobId)
        } else {
          const user = getUserData()
          this.navigateToFillProfilePage(user)
        }
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },
    profileIsComplete() {
      const profileData = localStorage.getItem('profileData')
      const result = JSON.parse(profileData)
      return profileData !== null && result && result.name
    },
    applyJob(token, job) {
      useJwt.applyJob({ token, job_opening_id: job }).then(response => {
        /* eslint-disable no-console */
        console.log('>>>>>>>>>>>>'+response)
        /* eslint-enable no-console */
        this.showToast('Job application successfully saved')
      }).catch(error => {
        console.log('errrorrrrrr'+error)
        const errorMessage = this.removeFirstChars(error.response.data.exception, 35)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Attention: Application Issues',
            icon: 'XOctagonIcon',
            variant: 'warning',
            text: errorMessage,
          },
        })
      })
    },
    navigateToFillProfilePage(userData) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: `Welcome ${userData.fullName || userData.username}`,
          icon: 'SmileIcon',
          variant: 'warning',
          text: 'Please complete your profile to continue+',
        },
      })
      this.$router.push({ name: 'careersprofile' })
    },
    showToast(message) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Success',
          icon: 'SmileIcon',
          variant: 'warning',
          text: message,
        },
      })
    },
    confirmSubmit(jobId) {
      const token = localStorage.getItem('accessToken')
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm(`You- have completed your profile, would you like to proceed to apply for ${jobId} position, with the currently available data? `, {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Apply',
          cancelTitle: 'Update profile',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: false,
        })
        .then(value => {
          this.boxTwo = value
          if (value) {
            console.log('we are here'+token+jobId)
            this.applyJob(token, jobId)
            
          } else {
            
            this.$router.push({ name: 'careersprofile' })
          }
        })
    },
    removeFirstChars(text, n) {
      return text.slice(n)
    },
  },
}
</script>

<style>

</style>
